import { Breadcrumbs } from "../../../AbstractElements";
import { Container, Row } from "reactstrap";
import { ECommerce, RecentOrders } from "../../../Constant";
import OrderHistoryData from "./OrderHistoryData";

const OrderHistoryContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={RecentOrders} parent={ECommerce} title={RecentOrders} />
      <Container fluid>
        <Row>
          <OrderHistoryData/>
        </Row>
      </Container>
    </>
  );
};

export default OrderHistoryContainer;
